import { Component, Input, OnInit } from '@angular/core';
import { assign } from 'lodash';
import { FlightResponse } from 'src/app/flight/models/FlightResponse';
import { FlightSegmentSch, OTAAirScheduleResponse, OriginDestinationOption } from '../models/OTAAirScheduleResponse';

@Component({
    selector: 'app-card-itinerary-flight',
    templateUrl: './card-itinerary-flight.component.html',
    styleUrls: ['./card-itinerary-flight.component.scss'],
    standalone: false
})
export class CardItineraryFlightComponent implements OnInit {

  @Input() flight: OriginDestinationOption;

  ngOnInit(): void {
    // avoid empty method
  }

}
